<template>
	<div style="width: 100%; background: #fff">
		<van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="信息"
			left-arrow @click-left="$router.back()" />
		<div style="height: 46px"></div>
		<!-- :style="{height: scrollerHeight}" -->
		<div class="IndCon" :style="{height: scrollerHeight}">
			<!-- allowfullscreen="true"-->
			<iframe name="link" scrolling="auto" frameborder="0" :src="url"></iframe>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		name: 'web',
		data() {
			return {
				url: "",
			}
		},
		created() {
			// 在接收页面，监听query变化并解码URL
			// this.url = this.$route.query.url ? decodeURIComponent(this.$route.query.url) : '';
			this.url = this.$route.query.url;
			console.log('innerHeight' + window.innerHeight); //innerHeight502
			console.log('clientHeight' + document.documentElement.clientHeight);
			// 接下来可以根据url加载内容或打开新页面
			// window.open(this.url, '_blank');
		},
		computed: {
			// 设置滚动区高度，减去头部标题和底部tabbar的高度
			scrollerHeight: function() {
				return (window.innerHeight - 46) + 'px';
			},
		},
		methods: {

		},
	}
</script>

<style lang="scss" scoped>
	.IndCon {
		// padding-top: 46px;
		// position: fixed;
		// top: 0;
		// left: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
		/* 滚动性能优化 */
	}

	iframe {
		width: 100%;
		height: 100%;
		border: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/web.vue